// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___aVIGK","totalContainer":"totalContainer___auB7Z"};